import React from "react";
import { View } from "react-native";
import RText from "../../../../RText";
import { Tote } from "../../../../../types/resultedRaces";

/**
 * RacecardAndResultWidgetToteReturns displays tote return information
 *
 * It shows the win, place, exacta, trifecta, and CSF tote returns if available
 *
 * @property {Tote[]} totes - Array of tote objects containing type and dividend information
 * @property {number} [csf] - The calculated CSF (Correct Score Forecast) value, if available
 *
 * @returns {JSX.Element | null} The RacecardAndResultWidgetToteReturns component or null if no totes are provided
 */

type Props = {
  totes: Tote[];
  csf?: number;
};

const RacecardAndResultWidgetToteReturns = ({ totes, csf }: Props) => {
  if (!(totes && totes.length)) return null;

  const winTote = totes.find((t) => t.tote_type === "Win");
  const placeTotes = totes.filter((t) => t.tote_type === "Place"); // Checking if there's actually more than one place
  const exactaTote = totes.find((t) => t.tote_type === "Exacta");
  const trifectaTote = totes.find((t) => t.tote_type === "Trifecta");

  const placeValues = placeTotes
    .map((t) => t.dividend?.formatted)
    .filter(Boolean)
    .join(", ");

  return (
    <View>
      <RText size="xs" weight="bold" uppercase color="x600">
        Tote Returns
      </RText>
      <RText size="xs" color="x600">
        {winTote && `Win: ${winTote.dividend?.formatted} `}
        {placeTotes.length > 0 && `Place: ${placeValues} `}
        {exactaTote && `Exacta: ${exactaTote.dividend?.formatted} `}
        {csf && `CSF: ${csf} `}
        {trifectaTote && `Trifecta: ${trifectaTote.dividend?.formatted}`}
      </RText>
    </View>
  );
};

export default RacecardAndResultWidgetToteReturns;
